import functionParser from '@ali/vu-function-parser';
import { error } from '@ali/re-utils';

function noop() {}

export function parseFunc(funcString) {
  return functionParser(funcString);
}

function parseModule(code) {
  let type = typeof code;
  let rawCode = code;

  if (type === 'object' && code.compiled != null) {
    rawCode = code.source;
    code = code.compiled;
    type = typeof code;
  }

  if (type === 'function') {
    return code;
  }

  if (type !== 'string') {
    error(`expect function "string", "${type}" given`, code);
    return null;
  }

  if (code.trim() === '') {
    return noop;
  }

  let func;

  try {
    func = new Function('exports', 'module', code);
  } catch (e) {
    error('解析 function 字符串失败，请检查字符串的合法性', e.message, `\n${rawCode}`);
    return null;
  }

  return (...args) => {
    try {
      return func.apply(this, args);
    } catch (e) {
      error('函数执行出错，请检查代码', e.message, '\n', func);
      return false;
    }
  };
}

export function parseActions(actions) {
  let list = [];

  if (Array.isArray(actions)) {
    list = actions;
  } else if (actions && typeof actions === 'object') {
    ({ list } = actions);
    if (Array.isArray(list) && actions.type === 'FUNCTION' && actions.module) {
      const mod = { exports: {} };
      const factory = parseModule(actions.module);
      if (factory) {
        factory(mod.exports, mod);
      }
      list = actions.list.map(item => ({
        ...item,
        func(...args) {
          let ret;
          try {
            ret = mod.exports[item.id].apply(this || context, args);
          } catch (e) {
            error(`exec action '${item.id}' error.`, e.message, '\n', mod.exports[item.id]);
          }
          return ret;
        },
      }));
    }
  }

  return list;
}
